/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Gpreasonplaceholder4Inputs */

const en_coinvestments_declinedeal_gpreasonplaceholder4 = /** @type {(inputs: Coinvestments_Declinedeal_Gpreasonplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a reason`)
};

/**
* | output |
* | --- |
* | "Select a reason" |
*
* @param {Coinvestments_Declinedeal_Gpreasonplaceholder4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_gpreasonplaceholder4 = /** @type {((inputs?: Coinvestments_Declinedeal_Gpreasonplaceholder4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Gpreasonplaceholder4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_gpreasonplaceholder4(inputs)
});
export { coinvestments_declinedeal_gpreasonplaceholder4 as "coInvestments_declineDeal_gpReasonPlaceholder" }